export interface PricingChange {
  label: string
  from: string
  to: string
}

const MISSING_VALUE = '—'

function toDisplayValue(value: unknown): string {
  if (value === null || value === undefined) {
    return MISSING_VALUE
  }

  const text = String(value).trim()

  if (text === '') {
    return MISSING_VALUE
  }

  return text
}

/**
 * A confirm dialog that says "you are changing live pricing" and nothing else asks the admin to
 * confirm an abstraction. This diffs the form's initial values against what they are about to
 * save so the dialog can list the actual before → after for each field they touched.
 *
 * Ordering follows `labels` rather than either value object, so the recap reads in the same
 * order as the form regardless of key insertion order.
 */
export function buildPricingRecap(
  before: Record<string, unknown>,
  after: Record<string, unknown>,
  labels: Record<string, string>,
): PricingChange[] {
  return Object.keys(labels).reduce<PricingChange[]>((changes, field) => {
    const from = toDisplayValue(before[field])
    const to = toDisplayValue(after[field])

    if (from === to) {
      return changes
    }

    changes.push({ label: labels[field], from, to })

    return changes
  }, [])
}
